import { render } from "./PageSearch.vue?vue&type=template&id=e1039658"
import script from "./PageSearch.vue?vue&type=script&lang=js"
export * from "./PageSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\PHPRad Projects\\ulcpv1\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__